import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  fileNotFoundError: {
    id: 'frontend-app-ora.ResponseDisplay.FileRenderer.fileNotFound',
    defaultMessage: 'File not found',
    description: 'File not found error message',
  },
  unknownError: {
    id: 'frontend-app-ora.ResponseDisplay.FileRenderer.unknownError',
    defaultMessage: 'Unknown errors',
    description: 'Unknown errors message',
  },
});

export default messages;
